import { CommonModule } from '@angular/common';
import { Component, SkipSelf, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { environment } from '../environments/environment';
import {
  AssessAuthoringCoreModule,
  ConfigService,
  LoadingSpinnerService,
  ProgramBanksService,
  RouterListenerService,
} from '@mhe/dle-assess-authoring-ui-submodules';
import { ButtonTrackerModule } from '@mhe/dle-assess-authoring-ui-submodules/air-context-interceptor';
import { LhToastModule } from '@mhe/lighthouse';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'aa-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterOutlet,
    AssessAuthoringCoreModule,
    ButtonTrackerModule,
    LhToastModule,
  ],
  providers: [
    RouterListenerService,
    {
      provide: LoadingSpinnerService,
      useFactory: (rootSpinnerService: LoadingSpinnerService) => rootSpinnerService,
      deps: [[new SkipSelf(), LoadingSpinnerService]],
    },
  ],
  standalone: true,
})
export class AppComponent {
  readonly showHeader = signal(false);
  readonly selectedBank = signal<
    ReturnType<ProgramBanksService['getSelectedProgram']> | null
  >(null);

  constructor(
    routerListenerService: RouterListenerService,
    private router: Router,
    private programBanksService: ProgramBanksService,
    private loadingSpinnerService: LoadingSpinnerService,
    private configService: ConfigService
  ) {
    routerListenerService.startListening();
    this.selectedBank.set(this.programBanksService.getSelectedProgram());

    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe((event: NavigationEnd) => {
        const isLoginRoute =
          event.url === '/' ||
          event.url === '/login' ||
          event.url.split('?')[0] === '/login';

        if (
          isLoginRoute
        ) {
          this.loadingSpinnerService.show();
        }

        this.showHeader.set(!isLoginRoute);
        this.selectedBank.set(this.programBanksService.getSelectedProgram());
      });

    this.configService.setConfig(environment);
  }
}
